import React from 'react';

// import Swiper React components
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';

// images
import team_image_alex from '../../assets/images/team/alex.png';
import team_image_belen from '../../assets/images/team/belen.png';
import team_image_ferran from '../../assets/images/team/ferran.png';
import team_image_jaime from '../../assets/images/team/jaime.png';
import team_image_ivan from '../../assets/images/team/ivan_cropped_resized.jpg';
import team_image_lili from '../../assets/images/team/lilibeth_cropped_resized.jpg';


const TestimonialSlider = () => {

    const data = [

        {
            image: team_image_jaime,
            testimony: 'Soy un psicólogo que le encanta estar en todos los saraos, desde HR, hasta Marketing.',
            name: 'Jaime Ferrández Latre',
            position: "Strategic Manager",
            superpower:"Transformar profundos insights del consumidor en resultados excepcionales. Experto en comportamiento. Mago de los Assestments."
        },
        {
            image: team_image_alex,
            testimony: '+20 años desarrollando negocios from scratch y llevarlas desde cero al primer millón.',
            name: 'Alexandra Díaz',
            position: "CEO & Founder",
            superpower:"Cazadora de oportunidades escondidas, creando el crecimiento de una marca imparable, pero no te voy a decir la receta de la casa..."
        },
        {
            image: team_image_ferran,
            testimony: 'De vigilante de seguridad a frontend.',
            name: 'Ferran Escudero',
            position: "Frontend",
            superpower:"Reinventarme a los 50 para convertirme en programador, soy el mejor ejemplo para demostrar lo que es capaz de lograr Woowii. No necesito Redbull para ir rápido, ya vengo con alas."
        },
        {
            image: team_image_belen,
            testimony: 'De Latinoamérica al mundo, una uruguaya sin miedo al éxito. ',
            name: 'Belén Martínez',
            position: "UX-UI Designer - QA Testing",
            superpower:"Tengo mucha personalidad, veo siempre más allá y voy poniéndole color a todo. Me apasiona el detalle, la estética y el testear para que la magia suceda."
        },
        {
            image:team_image_ivan,
            testimony: 'Mi mindset de negocio y desarrollo me hace un perfil único.',
            name: 'Iván Santamans',
            position: 'Tech Lead - Emprendedor',
            superpower: 'Soy un solucionador de desastres. Se ejecutar, hacer brillar un equipo, tomar decisiones rápidas y navegar por el salvaje mundo de la tecnología como Ninja.'
        },
        { 
            image:team_image_lili,
            testimony: 'Calzadora de piezas imposibles y amante de los puzzles.',
            name: 'Lili Real',
            position: 'Frontend & UX-UI',
            superpower: 'El ser estructurada me ha ayudado a tener paciencia y mucho atine en cuanto al desarrollo lógico del código, sin descuidar el estilo y la experiencia de usuario. No soy perfecta pero si alguien que ama lo que hace.'
        }
        // {
        //     image: team_image_enrique,
        //     testimony: '+9 años en el mundo de los drones y el código.',
        //     name: 'Enrique Martínez',
        //     position: "Tech Lead- Fullsatck- Emprendedor",
        //     superpower:"Solucionador de desastres.  Sé organizarme, tomar decisiones rápidas y navegar por el salvaje mundo de la tecnología como Ninja: muy techie, pero business orientated."
        // }
    ];

    return (
        <div className="testimonial-slider">
            <Swiper
                className='swiper-container'
                resizeObserver={true}
                spaceBetween={0}
                initialSlide={1}
                // init={false}
                speed={250}
                slideToClickedSlide={true}
                slidesPerView={1.7}
                loop={true}
                centeredSlides={true}
                breakpoints={{
                    0: {
                        direction: 'horizontal',
                    },
                    992: {
                        direction: 'vertical',
                    }
                }}
            >
                {
                    data.map((element, key) => {
                        return (
                            <SwiperSlide key={key}>
                                <div className="testimonial-slide">
                                    <div className="image">
                                        <div className="image-wrapper">
                                            <div className="image-inner">
                                                <img src={element.image} alt="testimony" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content">
                                        <div class="">
                                        <h3 class="m-0" style={{color:"black"}}>{element.name}</h3>
                                        <h4 class="m-0 ms-0 text-color-woowii-popeye">{element.position}</h4>
                                        </div>
                                        <p style={{color:"black"}}>{element.testimony}</p>
                                        <h4 class="m-0 ms-0 text-color-woowii-popeye">Superpower:</h4>
                                        <p style={{color:"black"}}>{element.superpower}</p>
                                        
                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
        </div>
    );
};

export default TestimonialSlider;
